module.exports = __webpack_public_path__ + "static/media/RealGrandeza.18b22f0f.svg";